import { Remotes } from './types';

export default [
  {
    url: 'https://acc-staging.autodesk.com/assets/projects/assets-no-cache/remoteEntry.js',
    scope: 'accProjectList',
    modules: {
      projectListModule: './ProjectList',
      projectTemplatesModule: './ProjectTemplates',
      providersModule: './ProvidersContainer',
      projectsHeaderLinksModule: './ProjectsHeaderLinks',
      productLinksModule: './ProductLinks',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/demo-app/assets-no-cache/remoteEntry.js',
    scope: 'accDemoApp',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/correspondence/assets-no-cache/remoteEntry.js',
    scope: 'accCorrespondence',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/meetings/assets-no-cache/remoteEntry.js',
    scope: 'accMeetings',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/photos/assets-no-cache/remoteEntry.js',
    scope: 'acsPhotos',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/rfis/assets-no-cache/remoteEntry.js',
    scope: 'accRfis',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/schedule/assets-no-cache/remoteEntry.js',
    scope: 'accSchedule',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/docs/assets-no-cache/remoteEntry.js',
    scope: 'accDocs',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/home/assets-no-cache/remoteEntry.js',
    scope: 'accUserHome',
    modules: {
      toolModule: './UserHome',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/submittals/assets-no-cache/remoteEntry.js',
    scope: 'accSubmittals',
    modules: {
      toolModule: './App',
    },
  },
  {
    url: 'https://acc-staging.autodesk.com/assets/specs/assets-no-cache/remoteEntry.js',
    scope: 'accSpecs',
    modules: {
      toolModule: './App',
    },
  },
] satisfies Remotes;
